import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import { ActionButtons } from "../../CenterList.styled";

const CenterAction = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus, companyId } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isCopyVisible, setCopyVisible] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);

  const history = useNavigate();
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState("");
  const [confirmationBoxContent, setConfirmationBoxContent] = useState("");

  const handleCenterStatus = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle(" COMPANY_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_ENABLE_CONTENT");
    } else {
      setConfirmationBoxTitle("COMPANY_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_DELETE_CONTENT");
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  const onCenterEditClick = () => {
    history(`/company/edit/${data.id}`);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .post(
          `/companies/${data.id}/updateStatus`,
          data.isActive === 1 ? `0` : 1
        )
        .then(() => {
          onRefreshData(true);
          setActionConfirmStatus(false);
        })
        .catch((error) => {
          onRefreshData(false);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <ActionButtons>
      <>
        {data.isActive === 1 && (
          <>
            <Image
              src={editIcon}
              onClick={onCenterEditClick}
              alt={t("CENTRE_ACTION_TOOLTIP_EDIT")}
              title={t("CENTRE_ACTION_TOOLTIP_EDIT")}
              styles={{ marginLeft: "7px" }}
              className="center-list__image-icon"
            />
            <Image
              src={deleteIcon}
              onClick={() => handleCenterStatus(0)}
              alt={t("CENTRE_ACTION_TOOLTIP_DISABLE")}
              title={t("CENTRE_ACTION_TOOLTIP_DISABLE")}
              styles={{ marginLeft: "7px" }}
              className="center-list__image-icon"
            />
          </>
        )}
        {data.isActive === 0 && (
          <Image
            src={activateIcon}
            onClick={() => handleCenterStatus(1)}
            alt={t("CENTRE_ACTION_TOOLTIP_ACTIVATE")}
            title={t("CENTRE_ACTION_TOOLTIP_ACTIVATE")}
            styles={{ marginLeft: "7px" }}
            className="center-list__image-icon"
          />
        )}
      </>
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ActionButtons>
  );
};

CenterAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(CenterAction);
